import styled from 'styled-components';
import { Link } from 'react-router-dom';

const MenuContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  background-color: ${({ theme }) => {
    return theme.colors.black;
  }};
  height: 50px;
  border-bottom-left-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
`;

MenuContainer.Profile = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;

  #profilePhoto {
    width: 30px;
    height: 30px;
    border: ${({ theme }) => {
      return theme.border;
    }};
    border-radius: 50%;
    margin-right: 5px;
  }

  h3 {
    margin: 0;
    padding: 0;
    color: ${({ theme }) => {
      return theme.colors.white;
    }};
    font-family: 'Ubuntu', sans-serif;
    font-size: ${({ theme }) => {
      return theme.fonts.size.small;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.normal;
    }};
    margin-right: 5px;
  }
`;

export const ConfigButton = styled(Link)`
  cursor: pointer;
  margin-left: 10px;
`;
export default MenuContainer;
